import React, { useContext, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn'
import EditIcon from '@mui/icons-material/Edit'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import EditRow from './EditRow'

const CategoryTable = ({
  category,
  setEditCategory,
  setSelectedCategory,
  data,
  setData,
  setChangesPresent,
  vehicleTypeOptions,
  isVehicleCleans,
}) => {
  const [editRow, setEditRow] = useState(null)

  return (
    <DetailsBox
      title={category}
      textButton={
        <EditIcon
          sx={{ fontSize: '1rem', cursor: 'pointer' }}
          color="anGrey"
          onClick={() => setEditCategory(category)}
        />
      }
      buttonRight={
        <Button
          onClick={() => setSelectedCategory(category)}
          variant="contained"
          size="small"
          startIcon={<DataSaverOnIcon />}
        >
          Add Field
        </Button>
      }
    >
      <Table padding="none">
        <TableHead>
          <TableRow sx={{ fontWeight: 'bold' }}>
            <TableCell sx={{ fontWeight: 'bold' }}>Title</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {isVehicleCleans ? 'Clean Type' : 'Standard'}
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Applicable To</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {data[category].map((item, index) => (
            <TableRow key={item.title}>
              <TableCell>{item.title}</TableCell>
              <TableCell>
                {isVehicleCleans ? item.cleanType.join(', ') : item.standard}
              </TableCell>
              <TableCell>
                {isVehicleCleans
                  ? (item.vehicleType ?? []).map((type, i) => {
                      // A renamed or removed vehicle type stays on the row,
                      // so flag it rather than letting it look applied.
                      const stale = !vehicleTypeOptions?.includes(type)
                      return (
                        <React.Fragment key={type}>
                          {i > 0 && ', '}
                          <Box
                            component="span"
                            title={
                              stale
                                ? 'No longer one of your vehicle types'
                                : undefined
                            }
                            sx={
                              stale
                                ? {
                                    color: 'warning.main',
                                    textDecoration: 'line-through',
                                  }
                                : undefined
                            }
                          >
                            {type}
                          </Box>
                        </React.Fragment>
                      )
                    })
                  : vehicleTypeOptions
                      .filter((x) => item.applicableTo.includes(x))
                      .join(', ')}
              </TableCell>
              <TableCell>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <EditIcon
                    sx={{ fontSize: '1rem', cursor: 'pointer' }}
                    color="anGrey"
                    onClick={() => setEditRow({ item, index })}
                  />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <EditRow
        row={editRow}
        categoryName={category}
        data={data}
        setData={setData}
        setChangesPresent={setChangesPresent}
        open={!!editRow}
        onClose={() => setEditRow(null)}
        vehicleTypeOptions={vehicleTypeOptions}
        isVehicleCleans={isVehicleCleans}
      />
    </DetailsBox>
  )
}

export default CategoryTable
